<template>
  <div class="item-container">
    <div class="item" v-if="item">
      <div class="title">ID:{{ item.id | zeroPadding}}</div>
      <div class="item-content">
        <div class="thumbnail">
          <object type="image/svg+xml" :data="svgUrl" style="width: 100%;"
                  :class="{normal:!direction,reverse:direction}" v-if="item"></object>
        </div>
        <div class="detail">
          <div><span class="label">サイズ</span> {{ height | centimeters }} x {{ width | centimeters }}</div>
          <div><span class="label">カラー</span> {{ color.name }}</div>
          <div><span class="label">向き</span> {{ direction ? '反転' : '正転' }}</div>
          <div><span class="label">単価</span> {{ price | money}}</div>
          <div><span class="label">枚数</span> {{ number }}枚</div>
        </div>
      </div>
      <div class="price"> {{ totalPrice | money }}</div>
    </div>
    <div class="container">
      <div class="buttons row" v-if="!fixed">
        <div class="col-6">
          <button class="btn button-change" @click="$emit('clickChange')">変更</button></div>
        <div class="col-6">
          <button class="btn button-delete" @click="$emit('clickDelete')">削除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CartItem',
    props: {
      'fixed': Boolean,
      'item_id': Number,
      'height': Number,
      'width': Number,
      'price': Number,
      'number': Number,
      'direction': Number,
      'color': Object,
      'item': Object,
      'uniq_key': String,
    },
    data() {
      return {
      };
    },
    computed: {
      styleObject () {
        if (this.color.color[0] === '/') {
          let id = '#' + this.color.color.substr(5, 3) + '.' + this.uniq_key;
          return {
            fill: 'url(' + id + ')',
            stroke: '',
          };
        } else {
          return {
            fill: this.color.color,
            stroke: ''
          };
        }
      },
      totalPrice () {
        return this.price * this.number;
      },
      svgUrl () {
        return `//admin.harigu.com/items/${this.item.id}.svg`
        + '?fill=' + this.styleObject.fill.replace('#', '%23');
      }
    },
  };
</script>

<style scoped lang="scss">
  .item-container {
    padding: 1rem 0.5rem 2rem;
    width: 100%;
    .item {
      justify-content: space-between;
      border: 0;
      border-radius: 0;
      width: inherit;
      height: inherit;
      .title {
        padding: 4px 1rem;
        background-color: rgb(128, 127, 128);
        color: #fff;
        text-align: right;
        border-radius: .5rem;
        margin-bottom: 1rem;
      }
      .item-content {
        display: flex;
        align-items: center;
        .thumbnail {
          width: 100px;
          max-height: 120px;
          filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
          .reverse {
            transform: scale(-1, 1);
          }
          figure {
            width: 100%;
            max-height: 100%;
            margin: 0;
            ::v-deep svg {
              width: 100%;
              height: 120px;
            }
          }
        }
        .detail {
          flex-grow: 1;
          margin-left: 1rem;
          .label {
            font-size: small;
            display: inline-block;
            width: 3rem;
            color: #666;
            &:after {
              content: ':'
            }
          }
        }
      }
      .price {
        text-align: right;
        font-weight: bold;
        font-size: large;
        margin-bottom: .4rem;
      }
    }

    .buttons {
      button {
        color: #f0f0f0;
        width: 100%;
        &.button-change {
          background-color: rgb(128, 127, 128);
        }
        &.button-delete {
          background-color: rgb(128, 87, 81);
        }
      }
    }
  }
</style>
